"use client";

import { useEffect, useState } from "react";
import Image from "next/image";

import s from "./styles";

import FooterCopyrightComponent from "./../../../FooterCopyright";

import logjs from "@metrojs/logjs";
const log = new logjs("login/page");

import { useLogin } from "./useLogin";
import { providers } from "@lib/client";
const { useWebAppContext } = providers;

/**
 * ログインページコンポーネント
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {Object} props.params - 動的ルートパラメータ
 * @param {Object} props.searchParams - URLのクエリパラメータ
 * @returns {JSX.Element} ログインページのコンポーネント
 */
export default function Page() {
  // コンテキストの使用
  const webAppContext = useWebAppContext();
  const { params, searchParams } = webAppContext || {};

  const { mode } = params;

  log.debug(`mode: ${mode}`, { params, searchParams });

  const [isMounted, setIsMounted] = useState(false);
  const [form, formProps] = useLogin();

  // ハイドレーションを無効にする
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Enterキーでログイン
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      formProps.login();
    }
  };

  if (!isMounted) {
    return null;
  }

  const isDisplayUnder = mode == undefined || mode == "truck_ichi" || mode == "kyoto_seibi";

  log.debug(`isDisplayUnder: ${isDisplayUnder} mode: ${mode}`);

  // @@@ コメントアウト確認
  let logo_name = "do_logo_only.svg";
  let jimu_name = "ダイレクトオーダー事務局";
  let loginform_name = "部品を買う → 会員様ログイン";
  // let loginform_name = "部品を買う/車輌を売る → 会員様ログイン";
  if (mode == "bs") {
    logo_name = "bs_logo.png";
    jimu_name = "ダイレクトオーダー事務局";
    loginform_name = "部品を買う → 会員様ログイン";
    // loginform_name = "部品を買う/車輌を売る → 会員様ログイン";
  } else if (mode == "truck_ichi") {
    logo_name = "truck-ichi_logo.png";
    jimu_name = "ダイレクトオーダー事務局";
    loginform_name = "部品を買う → 会員様ログイン";
    // loginform_name = "部品を買う/車輌を売る → 会員様ログイン";
  } else if (mode == "kyoto_seibi") {
    logo_name = "kyoto-seibi_logo.png";
    jimu_name = "ダイレクトオーダー事務局";
    //loginform_name = "部品を買う → 会員様ログイン";
    // loginform_name = "部品を買う/車輌を売る → 会員様ログイン";
  } else if (mode == "aspc") {
    logo_name = "yk_logo.png";
    jimu_name = "ASパーツ事務局";
    loginform_name = "部品を買う → 会員様ログイン";
  } else if (mode == "finalparts") {
    logo_name = "final_parts_logo.png";
    jimu_name = "FinalParts事務局";
    loginform_name = "部品を買う → 会員様ログイン";
  } else if (mode == "ichinen") {
    logo_name = "ichinen_logo.png";
    jimu_name = "イチネンパーツ事務局";
    loginform_name = "部品を買う → 会員様ログイン";
  } else if (mode == "junps") {
    logo_name = "junps_logo.png";
    jimu_name = "JU長野パーツサービス事務局";
    loginform_name = "部品を買う → 会員様ログイン";
  } else {
    logo_name = "do_logo_only.svg";
    jimu_name = "ダイレクトオーダー事務局";
    loginform_name = "部品を買う → 会員様ログイン";
    // loginform_name = "部品を買う/車輌を売る → 会員様ログイン";
  }
  document.body.style.backgroundImage = "url(/images/bg.png)";
  document.body.style.backgroundColor = "";
  return (
    <>
      {mode == "kyoto_seibi" ? (
        <s.BodyBackgroundKyotoSeibi>
            <s.HeaderKyotoSeibi>
              <s.ContainerKyotoSeibi>
                <s.Logo1KyotoSeibi>
                  <Image src={`/images/original_logo.png`} alt="DirectOrder" width={150} height={40} style={{ maxHeight: "48px", width: "auto" }} />
                </s.Logo1KyotoSeibi>
                <s.Logo2KyotoSeibi>
                  京都府自動車整備商工組合
                </s.Logo2KyotoSeibi>
              </s.ContainerKyotoSeibi>
            </s.HeaderKyotoSeibi>

            <s.ContainerLoginKyotoSeibi>
                <s.LoginBoxKyotoSeibi>
                  <s.LoginFormKyotoSeibi>
                    <s.LoginContentKyotoSeibi>
                      <s.LoginTableKyotoSeibi>
                        <tbody>
                          <tr>
                            <th>ID</th>
                            <td>
                              {formProps.input_login_id({
                                maxLength: 16,
                                onKeyPress: handleKeyPress,
                              })}
                            </td>
                          </tr>
                          <tr>
                            <th>パスワード</th>
                            <td>
                              {formProps.input_password({
                                maxLength: 100,
                                onKeyPress: handleKeyPress,
                              })}
                            </td>
                          </tr>
                        </tbody>
                      </s.LoginTableKyotoSeibi>

                      {form?.error && <s.ErrorMessageKyotoSeibi>{form?.error}</s.ErrorMessageKyotoSeibi>}

                      <s.LoginButtonKyotoSeibi
                        onClick={(e) => {
                          e.preventDefault();
                          formProps.login(mode);
                        }}
                        disabled={form?.loading}
                      >
                        {form?.loading ? "ログイン中..." : "ログイン"}
                      </s.LoginButtonKyotoSeibi>
                    </s.LoginContentKyotoSeibi>
                  </s.LoginFormKyotoSeibi>
                </s.LoginBoxKyotoSeibi>
            </s.ContainerLoginKyotoSeibi>
            <s.FooterCopyrightContainer>
              <FooterCopyrightComponent mode={mode} />
            </s.FooterCopyrightContainer>
          </s.BodyBackgroundKyotoSeibi>
      ) : ( 
        <s.BodyBackground>
          <s.LoginContainer style={{ backgroundColor: "transparent" }}>
            <s.Header>
              <s.Logo style={{ backgroundColor: mode == "ichinen" ? "beige" : "#000 url('/images/header_bg.jpg') 50% 0 no-repeat" }}>
                <Image src={`/images/${logo_name}`} alt="DirectOrder" width={150} height={40} style={{ maxHeight: "48px", width: "auto" }} />
              </s.Logo>

              <s.Container>
                <s.Main>
                  <s.LoginBox>
                    <s.LoginForm>
                      <s.LoginTitle>{loginform_name}</s.LoginTitle>
                      <s.LoginContent>
                        <s.LoginTable>
                          <tbody>
                            <tr>
                              <th>ID</th>
                              <td>
                                {formProps.input_login_id({
                                  maxLength: 16,
                                  onKeyPress: handleKeyPress,
                                })}
                              </td>
                            </tr>
                            <tr>
                              <th>パスワード</th>
                              <td>
                                {formProps.input_password({
                                  maxLength: 100,
                                  onKeyPress: handleKeyPress,
                                })}
                              </td>
                            </tr>
                          </tbody>
                        </s.LoginTable>

                        {form?.error && <s.ErrorMessage>{form?.error}</s.ErrorMessage>}

                        <s.LoginButton
                          onClick={(e) => {
                            e.preventDefault();
                            formProps.login(mode);
                          }}
                          disabled={form?.loading}
                        >
                          {form?.loading ? "ログイン中..." : "ログイン"}
                        </s.LoginButton>
                      </s.LoginContent>
                    </s.LoginForm>
                  </s.LoginBox>

                  <s.MessageArea>
                    <s.MessageContent>
                      <h1>{jimu_name}</h1>
                      <p>
                        <strong>TEL:092-710-3912</strong>
                        <span>(平日 10:00～17:00)</span>
                        <br />
                        ・申込みに関するお問合せ
                        <br />
                        ・操作方法に関するお問合せ
                        <br />
                        ・ID、パスワードに関するお問合せ
                        <br />
                        ・その他の一般的なお問合せ
                        <span className="emergency">
                          ■サーバ障害　緊急連絡専用
                          <br />
                          <a href="mailto:support@direct-order-sys.jp">
                            support@direct-order-sys.jp
                            {/* <Image src="/images/emergency.png" alt="緊急連絡" width={160} height={100} /> */}
                          </a>
                          <br />
                          ・サーバ障害に関する緊急連絡専用となります。
                        </span>
                      </p>
                    </s.MessageContent>
                  </s.MessageArea>
                </s.Main>
              </s.Container>
            </s.Header>
          </s.LoginContainer>

          <s.MainContent>
            {isDisplayUnder && (
              <s.Footer>
                自動車の中古・リビルド・優良パーツ(部品)をお探しなら、ダイレクトオーダーで。
                <br />
                <br />
                自動車パーツの一括見積システムです。
                <br />
                在庫を検索するのではありませんので、フロントマン様・ご担当者様の手間を軽減しコストカット。
                <br />
                中古・リビルドパーツのヒット率向上もダイレクトオーダーにお任せください。
                <br />
                <br />
                <a href="https://www.direct-order.jp/">&raquo;「ダイレクトオーダー」の資料請求、お問合せはコチラをご確認ください。</a>
                <br />
                <br />
                ※自動車リサイクルパーツ・リビルドパーツサプライヤー様もお待ちしております。
                <p className="contact">
                  {" "}
                  ■ダイレクトオーダー事務局
                  <br />
                  &emsp;TEL:<strong>092-710-3912</strong> <span>(平日 10:00～17:00)</span>{" "}
                </p>
              </s.Footer>
            )}
          </s.MainContent>

          <s.FooterCopyrightContainer>
            <FooterCopyrightComponent mode={mode} />
          </s.FooterCopyrightContainer>
        </s.BodyBackground>
      )}
    </>
  );
}
